import React from "react";
import { Link } from "react-router-dom";

import logo from "../assets/logo.svg";

const Hero = () => (
  <div className="text-center hero my-5">
    <img className="mb-3 app-logo" src={logo} alt="React logo" width="120" />
    <h1 className="mb-4">IoT Taxi Monitoring by Sensational Systems</h1>

    <p className="lead">
      Already a user? <Link to="/view">Log in to view your car park</Link>
    </p>
  </div>
);

export default Hero;
